import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Paper,
} from "@mui/material";
import { doc, getDoc, addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebaseConfig.js";
import { useAuth } from "../../context/AuthContext.js";

const Content = () => {
  const { currentUser } = useAuth();
  const [fullName, setFullName] = useState("");
  const [contentType, setContentType] = useState("blog"); // "blog" o "promotion"
  const [formData, setFormData] = useState({
    title: "",
    subtitle: "",
    content: "",
    media: "",
  });

  // Obtener el fullName del usuario autenticado
  useEffect(() => {
    const fetchFullName = async () => {
      if (currentUser) {
        try {
          const userDocRef = doc(db, "users", currentUser.uid); // Suponiendo que el ID del usuario es el UID
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            setFullName(userDoc.data().fullName || ""); // Asignar fullName o un valor por defecto
          } else {
            console.warn("No se encontró el documento del usuario.");
          }
        } catch (error) {
          console.error("Error al obtener el fullName:", error);
        }
      }
    };
    fetchFullName();
  }, [currentUser]);

  // Manejar cambios en los campos del formulario
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Cambiar el tipo de contenido (blog o promoción)
  const handleContentTypeChange = (event) => {
    setContentType(event.target.value);
    setFormData({ title: "", subtitle: "", content: "", media: "" });
  };

  // Manejar el envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentUser || !fullName) {
      alert("No se puede identificar al usuario. Intenta iniciar sesión nuevamente.");
      return;
    }

    try {
      const collectionName = contentType === "blog" ? "blogs" : "promotions";
      const dataToSave = {
        title: formData.title,
        subtitle: formData.subtitle || null,
        content: formData.content || null,
        media: formData.media || null,
        author: fullName,
        createdAt: serverTimestamp(),
      };

      await addDoc(collection(db, collectionName), dataToSave);
      alert(`${contentType === "blog" ? "Blog" : "Promoción"} creado con éxito.`);
      setFormData({ title: "", subtitle: "", content: "", media: "" });
    } catch (error) {
      console.error("Error al crear el contenido:", error);
      alert("Hubo un error al crear el contenido. Intenta nuevamente.");
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" sx={{ textAlign: "center", mb: 3 }}>
          Administrar Contenido
        </Typography>
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="content-type-label">Tipo de Contenido</InputLabel>
          <Select
            labelId="content-type-label"
            value={contentType}
            onChange={handleContentTypeChange}
          >
            <MenuItem value="blog">Blog</MenuItem>
            <MenuItem value="promotion">Promoción</MenuItem>
          </Select>
        </FormControl>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Título"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            required
            sx={{ mb: 3 }}
          />
          {contentType === "blog" && (
            <TextField
              fullWidth
              label="Subtítulo"
              name="subtitle"
              value={formData.subtitle}
              onChange={handleInputChange}
              sx={{ mb: 3 }}
            />
          )}
          {contentType === "blog" && (
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Contenido"
              name="content"
              value={formData.content}
              onChange={handleInputChange}
              sx={{ mb: 3 }}
            />
          )}
          <TextField
            fullWidth
            label={
              contentType === "blog"
                ? "URL de la imagen o video de YouTube"
                : "URL de la imagen o video"
            }
            name="media"
            value={formData.media}
            onChange={handleInputChange}
            sx={{ mb: 3 }}
          />
          <Button variant="contained" color="primary" type="submit" fullWidth>
            Crear {contentType === "blog" ? "Blog" : "Promoción"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default Content;
